import { render, staticRenderFns } from "./chooseUsers.vue?vue&type=template&id=f2ed06f2&scoped=true"
import script from "./chooseUsers.vue?vue&type=script&lang=ts"
export * from "./chooseUsers.vue?vue&type=script&lang=ts"
import style0 from "./chooseUsers.vue?vue&type=style&index=0&id=f2ed06f2&prod&lang=scss&scoped=true"
import style1 from "./chooseUsers.vue?vue&type=style&index=1&id=f2ed06f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ed06f2",
  null
  
)

export default component.exports